import Button from '../../core/components/Button'
import styled from 'styled-components'

export const RegLogButton = styled(Button)`
  padding-top: 15px;
  padding-bottom: 15px;
  margin-top: 10px;
  margin-bottom: 0;
`
